import { render } from "./component_toggle.vue?vue&type=template&id=bb5e7936"
import script from "./component_toggle.vue?vue&type=script&lang=js"
export * from "./component_toggle.vue?vue&type=script&lang=js"

import "./component_toggle.vue?vue&type=style&index=0&id=bb5e7936&lang=css"

import exportComponent from "/Users/patrikhubner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__